const ABOUT_IMG =
  "https://images.unsplash.com/photo-1757017199822-beab923a1afc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbmRpYW4lMjB3ZWRkaW5nJTIwY291cGxlfGVufDB8fHx8MTc3ODQ5NjUzMHww&ixlib=rb-4.1.0&q=85";

const stats = [
  { value: "120+", label: "Weddings Designed" },
  { value: "3", label: "Countries" },
  { value: "10", label: "Years Together" },
];

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-40 px-6 md:px-12 lg:px-24 overflow-hidden"
    >
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 relative reveal">
          <div className="relative overflow-hidden">
            <img
              src={ABOUT_IMG}
              alt="Nishi Bajaj · Founder of Bon Evento · Luxury Wedding Planner Mumbai"
              className="w-full h-[520px] md:h-[640px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#080B12]/40 to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-6 md:-bottom-10 md:-right-10 bg-[#121623] border border-[#F0EBE1]/10 px-6 py-5 md:px-8 md:py-6">
            <div className="overline mb-2">The Founder</div>
            <div className="font-serif text-2xl md:text-3xl text-[#F0EBE1]">
              Nishi <span className="italic text-[#B8935C]">Bajaj</span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 lg:pl-12 reveal" data-testid="about-content">
          <div className="overline mb-6">About Us</div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#F0EBE1]">
            The visionary
            <br />
            behind <span className="italic text-[#B8935C]">Bon Evento</span>.
          </h2>

          <div className="mt-10 space-y-6 max-w-xl text-[#F0EBE1]/75 text-base sm:text-lg leading-relaxed font-light">
            <p>
              Hailing from Mumbai, Nishi Bajaj is a devoted luxury wedding
              planner, wedding designer and decor stylist — crafting bespoke
              destination wedding experiences across India and the world.
            </p>
            <p>
              From editorial wedding decor and celebrity weddings to intimate
              palace celebrations and beachside destination weddings, her
              studio turns ordinary moments into extraordinary memories
              tailored to every couple's love story.
            </p>
            <p className="text-[#F0EBE1]/55 italic font-serif text-lg">
              Together, let us craft memories that will be cherished forever.
            </p>
          </div>

          <div className="mt-16 md:mt-20 border-t border-[#F0EBE1]/10 pt-12">
            <div className="overline mb-8">By the numbers</div>
            <div className="grid grid-cols-3 gap-6 sm:gap-10">
              {stats.map((s, i) => (
                <div
                  key={s.label}
                  data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="relative"
                >
                  <div className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl text-[#B8935C] font-light leading-none tracking-tight">
                    {s.value}
                  </div>
                  <div className="mt-3 h-px w-10 bg-[#B8935C]/40" />
                  <div className="mt-4 text-[10px] sm:text-xs uppercase tracking-[0.28em] text-[#F0EBE1]/65 font-light leading-snug">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
